export const config = {
  environment: process.env.REACT_APP_ENVIRONMENT,
  domain: process.env.REACT_APP_DOMAIN,
  startApplicationUrl: process.env.REACT_APP_START_APPLICATION_URL
}
